// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { DoctorActions, DoctorActionTypes } from '../_actions/doctor.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Doctor } from '../_models/doctor.model';

// tslint:disable-next-line:no-empty-interface
export interface DoctorsState extends EntityState<Doctor> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedDoctorId: number;
  lastCreatedDoctor: Doctor;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Doctor> = createEntityAdapter<Doctor>();

export const initialDoctorsState: DoctorsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedDoctorId: undefined,
  lastCreatedDoctor: undefined,
  latestSuccessfullAction: null,
  showInitWaitingMessage: true,
});

export function doctorsReducer(state = initialDoctorsState, action: DoctorActions): DoctorsState {
  switch (action.type) {
    case DoctorActionTypes.DoctorsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedDoctorId: undefined,
      };
    case DoctorActionTypes.DoctorsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case DoctorActionTypes.DoctorOnServerCreated:
      return {
        ...state,
      };
    case DoctorActionTypes.DoctorOnServerUpdated:
      return {
        ...state,
      };
    case DoctorActionTypes.DoctorStatusOnServerUpdated:
      return {
        ...state,
      };
    case DoctorActionTypes.DoctorOnServerDeleted:
      return {
        ...state,
      };
    case DoctorActionTypes.DoctorCreated:
      return adapter.addOne(action.payload.doctor, {
        ...state,
        lastCreatedDoctorId: action.payload.doctor.id,
        lastCreatedDoctor: action.payload.doctor,
      });
    case DoctorActionTypes.DoctorUpdated:
      return adapter.updateOne(action.payload.partialDoctor, state);
    case DoctorActionTypes.DoctorStatusUpdated: {
      // tslint:disable-next-line
      const _partialDoctor: Update<Doctor> = {
        id: action.payload.id,
        changes: {
          is_active: action.payload.is_active,
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialDoctor, state);
    }
    case DoctorActionTypes.DoctorDeleted:
      return adapter.removeOne(action.payload.id, state);
    case DoctorActionTypes.DoctorsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case DoctorActionTypes.DoctorsPageLoaded: {
      return adapter.addMany(action.payload.doctors, {
        ...initialDoctorsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    case DoctorActionTypes.ThrowError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case DoctorActionTypes.ClearErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case DoctorActionTypes.FireDoctorSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getDoctorState = createFeatureSelector<DoctorsState>('doctors');

export const { selectEntities, selectIds, selectTotal } = adapter.getSelectors();
